/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-28 12:17:13
 * @LastEditTime: 2022-01-28 21:10:29
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/HsbMarketPlatform/merchant/index.jsx
 */

import { Button, message } from 'antd';
import React, { useRef, useState } from 'react'
import { dicRecvCertType, mapMerchantCardType } from '../../../axios/dictionaries';
import AuthButton from '../../../components/AuthButton/AuthButton';
import PageWrap from '../../../components/PageWrap'
import TableHelper from '../../../components/TableHelper'
import { fetchHSBMarketPlatformMerchantList,fetchHSBMarketPlatformMerchantSyncData } from "../../../services/HSBMarketPlatform";
import { findDict, formatTime } from '../../../utils';
import HsbMarketPlatformMerchantDetail from './detail';
const HsbMarketPlatformMerchant = (props) => {
    const [loading, setLoading] = useState(false);
    let HsbMarketPlatformMerchantDetailRef = null 
    let TableHelperRef = useRef()
    const handleSyncData = () => {
        postSyncData().then(() => {
            TableHelperRef.current.postDataSource()
        })
    }
    const postSyncData = () => {
        setLoading(true)
        return fetchHSBMarketPlatformMerchantSyncData().then(res => {
            message.success('同步成功')
        }).finally(() => {
            setLoading(false)
        })    
    }

    const searchOptions = [
        { key: 'keyword', type: 'input', placeholder: '市场商家编号或市场商家名称'}
    ]
    const columns = [
        { title: '市场编号', dataIndex: 'mktId', },
        { title: '市场商家名称', dataIndex: 'mktMrchNm', },
        { title: '市场商家编号', dataIndex: 'mktMrchId', },
        { title: '联系人名称', dataIndex: 'ctcpsnNm', },
        { title: '商家柜台代码', dataIndex: 'mrchCnterCd', },
        { title: '商家证件类型', dataIndex: 'mrchCrdtTp', render: (text) => {
            return findDict(mapMerchantCardType, text).title
        } },
        { title: '商家证件号码', dataIndex: 'mrchCrdtNo', },
        { title: 'POS编号', dataIndex: 'posNo', },
        { title: '商家自定义编号', dataIndex: 'udfId', },
        { title: '同步时间', dataIndex: 'updateTime', render: formatTime},
        { title: '操作', dataIndex: 'actions', fixed: 'right', width: 60, render: (text, record) => {
            return <React.Fragment>
                <AuthButton authkey="h-7-2">
                    <a onClick={() =>HsbMarketPlatformMerchantDetailRef.open(record.id)}>详情</a>
                </AuthButton>
            </React.Fragment>
        } }
    ]
    return (
        <PageWrap>
            <TableHelper getRef={ref => TableHelperRef.current = ref} searchOptions={searchOptions} columns={columns} scroll={{ x: 2000 }} request={fetchHSBMarketPlatformMerchantList} >
                <div slot="search">
                    <AuthButton authkey="h-7-3">
                        <Button type="primary" loading={loading} onClick={handleSyncData}>同步数据</Button>
                    </AuthButton>
                </div>
            </TableHelper>
            <HsbMarketPlatformMerchantDetail getRef={ref => HsbMarketPlatformMerchantDetailRef = ref} />
        </PageWrap>
    )
}

export default HsbMarketPlatformMerchant 


// WEBPACK FOOTER //
// ./src/page/HsbMarketPlatform/merchant/index.jsx